import React from 'react';
import apiService from '../../../services/api';
// import "./GerenciarCadastro.css";
import Navbar from '../../../components/layout/Navbar/Navbar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import { ESTABELECIMENTO_SAUDE_SIDEBAR } from '../../../constants/sidebarConfig';

const GerenciarCadastro = () => {

  return (
    <div className="gerenciarCadastro">
      <div className="navbar">
        <Navbar onLogout={apiService.logout}/>
      </div>
      <div className="container">
        <div className="sidebar">
          <Sidebar items={ESTABELECIMENTO_SAUDE_SIDEBAR}/>
        </div>
        <div className="main-content">
        </div>
      </div>
    </div>
  );
};

export default GerenciarCadastro;